module.exports = __webpack_public_path__ + "img/acaso.211a9a6e.png";